module.exports = __webpack_public_path__ + "static/media/angle-right-current.741006e6.svg";